export default __webpack_public_path__ + "media/color/xtz-bec76b43.svg";